import { Component, inject, input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import {
  MessageBarStore,
  Modal,
  ResolvableModal,
  SOFTLINE_FEATURE_MESSAGE_BAR } from '@softline/ui-core';
import { ReactiveFormsModule, UntypedFormBuilder, Validators } from '@angular/forms';
import { NewTicketDocument } from '../../data/document.model';
import { Ticket } from '../../data/ticket.model';
import { RequestError, Store } from '@softline/core';
import { SOFTLINE_FEATURE_TICKET_DOCUMENT } from '../../ticket.shared';
import { TicketDocumentsStore } from '../../store/document.store';
import { showRequestErrors } from '@softline/application';
import { CommonModule } from '@angular/common';

import { FileInputComponent } from '@softline/ui-core';
import { TranslatePipe } from '@softline/ui-core';
@Component({
  selector: 'lib-create-document',
  imports: [CommonModule, ReactiveFormsModule,
    FileInputComponent,
    TranslatePipe],
  templateUrl: './create-document.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./create-document.component.css'] })
export class CreateDocumentComponent extends ResolvableModal<any> implements OnInit {
  private store = inject(Store);
  private fb = inject(UntypedFormBuilder);

  // tslint:disable-next-line:variable-name
  //private _ticket!: Ticket;
  ticket = input<Ticket>();

  form = this.fb.group({
    ticketId: ['', Validators.required],
    files: ['', Validators.required] });

  uploadState$ = this.store.observe(
    SOFTLINE_FEATURE_TICKET_DOCUMENT,
    TicketDocumentsStore.getters.uploadProgress
  );

  ngOnInit(): void {
    const value = this.ticket();
    if (!value) {
      return;
    }
    this.form.patchValue({ ticketId: value.id });
  }

  async onSubmit(): Promise<void> {
    const documents: NewTicketDocument[] = this.form.value.files.map((file) => ({
      ticketId: this.ticket()?.id,
      files: [file] }));
    try {
      for (const document of documents) {
        await this.store.dispatch(
          SOFTLINE_FEATURE_TICKET_DOCUMENT,
          TicketDocumentsStore.actions.upload,
          { entity: document }
        );
      }
      await this.store.dispatch(
        SOFTLINE_FEATURE_MESSAGE_BAR,
        MessageBarStore.actions.success,
        `#TICKETS.MESSAGES.DOCUMENT_ADD.SUCCESS.${1 === 1 ? 'SINGULAR' : 'PLURAL'}`
      );
      this.resolve(documents);
    } catch (e) {
      if (e instanceof RequestError) {
        await this.store.dispatch(
          SOFTLINE_FEATURE_MESSAGE_BAR,
          MessageBarStore.actions.error,
          `#TICKETS.MESSAGES.DOCUMENT_ADD.FAILURE.${1 === 1 ? 'SINGULAR' : 'PLURAL'}`
        );
      } else {
        showRequestErrors(this.store, e);
      }
    }
  }
}
